import {
  MovimentacaoDetalhe,
  RequerimentoTransferencia,
  PainelClaros,
  MovimentacaoTipo,
  MovimentacaoStatus,
  RequerimentoStatus
} from '../models';

export const MOVIMENTACOES_FIXTURE: MovimentacaoDetalhe[] = [
  {
    id: '1',
    matricula: '202356',
    nomePolicial: 'Maj QOPM Fabiana Alves',
    postoGraduacao: 'Major',
    tipo: MovimentacaoTipo.TRANSFERENCIA,
    unidadeOrigemId: '1',
    unidadeOrigemNome: '1º BPM (Asa Sul)',
    unidadeDestinoId: '3',
    unidadeDestinoNome: '3º BPM (Asa Norte)',
    dataEntrada: '2026-05-18',
    numeroSei: '00054.000210/2026-89',
    status: MovimentacaoStatus.EFETIVADA,
    responsavelNome: 'TC QOPM Silva Costa',
    publicacaoDodf: 'BCG nº 090 de 16/05/2026',
    dataPublicacaoDodf: '2026-05-16',
    motivo: 'Interesse do Serviço (Ajuste de Efetivo)',
    observacoes: 'Oficial assume Seção de Planejamento.',
    manterPerfilSistema: false,
    dataCriacao: '2026-05-18T10:00:00Z',
  },
  {
    id: '2',
    matricula: '354210',
    nomePolicial: 'Sgt QPPMC Renata Souza',
    postoGraduacao: 'Sargento',
    tipo: MovimentacaoTipo.TRANSFERENCIA,
    unidadeOrigemId: '3',
    unidadeOrigemNome: '3º BPM (Asa Norte)',
    unidadeDestinoId: '9',
    unidadeDestinoNome: '9º BPM (Gama)',
    dataEntrada: '2026-05-20',
    numeroSei: '00054.000450/2026-12',
    status: MovimentacaoStatus.EFETIVADA,
    responsavelNome: 'DGP Gestor Operacional',
    publicacaoDodf: 'BCG nº 092 de 18/05/2026',
    dataPublicacaoDodf: '2026-05-18',
    motivo: 'A Pedido (Aproximação Familiar)',
    observacoes: 'Respeita o tempo mínimo regulamentar de 2 anos na unidade anterior.',
    manterPerfilSistema: false,
    dataCriacao: '2026-05-20T14:30:00Z',
  },
  {
    id: '3',
    matricula: '109250',
    nomePolicial: 'TC QOPM Marcos Silveira',
    postoGraduacao: 'Tenente Coronel',
    tipo: MovimentacaoTipo.INATIVIDADE,
    unidadeOrigemId: '1',
    unidadeOrigemNome: '1º BPM (Asa Sul)',
    unidadeDestinoId: null,
    unidadeDestinoNome: null,
    dataEntrada: '2026-05-24',
    numeroSei: '00054.000998/2026-77',
    status: MovimentacaoStatus.EFETIVADA,
    responsavelNome: 'DPM Inatividade Gestor',
    publicacaoDodf: 'DODF nº 098 de 23/05/2026',
    dataPublicacaoDodf: '2026-05-23',
    motivo: 'Passagem para Reserva Remunerada (Tempo de Serviço)',
    observacoes: 'Militares desligados de OPM ativas. Status funcional passa a Inativo.',
    manterPerfilSistema: false,
    dataCriacao: '2026-05-24T08:15:00Z',
  },
];

export const REQUERIMENTOS_FIXTURE: RequerimentoTransferencia[] = [
  {
    id: '1',
    policialId: '98',
    matricula: '302488',
    nomePolicial: 'Sd QPPMC Daniel Costa',
    postoGraduacao: 'Soldado',
    comportamento: 'EXCELENTE',
    unidadeOrigemId: '1',
    unidadeOrigemNome: '1º BPM (Asa Sul)',
    unidadeDesejadaId: '3',
    unidadeDesejadaNome: '3º BPM (Asa Norte)',
    motivoJustificativa: 'Solicito transferência devido a problemas de saúde familiar e para facilitar aproximação com meu domicílio atual.',
    parecerChefiaOrigem: 'Favorável. Militar cumpre todos os requisitos de tenure mínima.',
    parecerChefiaOrigemPor: 'Cap QOPM André Neves',
    parecerChefiaDestino: null,
    parecerChefiaDestinoPor: null,
    decisaoDp: null,
    decisaoDpPor: null,
    statusWorkflow: RequerimentoStatus.PENDENTE_DP,
    dataCriacao: '2026-05-22T09:00:00Z',
    anexoUrl: 'laudo_medico_anexo_pdf',
  },
];

export const CLAROS_FIXTURE: PainelClaros[] = [
  { unidadeId: '1', unidadeNome: '1º BPM (Asa Sul)', cargoPosto: 'Geral', vagasPrevistas: 120, efetivoAtual: 102, deficitSuperavit: -18, percentualRestricoes: 10 },
  { unidadeId: '3', unidadeNome: '3º BPM (Asa Norte)', cargoPosto: 'Geral', vagasPrevistas: 100, efetivoAtual: 96, deficitSuperavit: -4, percentualRestricoes: 12 },
  { unidadeId: '9', unidadeNome: '9º BPM (Gama)', cargoPosto: 'Geral', vagasPrevistas: 80, efetivoAtual: 78, deficitSuperavit: -2, percentualRestricoes: 5 },
  { unidadeId: '12', unidadeNome: '12º BPM (Ceilândia)', cargoPosto: 'Geral', vagasPrevistas: 150, efetivoAtual: 148, deficitSuperavit: -2, percentualRestricoes: 8 },
  { unidadeId: 'DITEL', unidadeNome: 'DITEL (Tecnologia)', cargoPosto: 'Geral', vagasPrevistas: 45, efetivoAtual: 50, deficitSuperavit: 5, percentualRestricoes: 2 },
];
